"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createConnectMessage = exports.ClientMessageTypes = void 0;
var AppMessages_1 = require("./AppMessages");
var ClientMessageTypes;
(function (ClientMessageTypes) {
  ClientMessageTypes["Connect"] = "Connect";
  ClientMessageTypes["GetInfo"] = "GetInfo";
  ClientMessageTypes["GetPendingRequests"] = "GetPendingRequests";
  ClientMessageTypes["ResolveSignTransaction"] = "ResolveSignTransaction";
  ClientMessageTypes["ResolveSignMessage"] = "ResolveSignMessage";
  ClientMessageTypes["RejectRequest"] = "RejectRequest";
  ClientMessageTypes["EndSession"] = "EndSession";
  ClientMessageTypes["GetSessions"] = "GetSessions";
})(ClientMessageTypes = exports.ClientMessageTypes || (exports.ClientMessageTypes = {}));
var createConnectMessage = function createConnectMessage(publicKey, sessionId, token, notificationEndpoint, device, metadata) {
  return {
    type: ClientMessageTypes.Connect,
    version: AppMessages_1.Version.V1,
    publicKey: publicKey,
    sessionId: sessionId,
    token: token,
    notificationEndpoint: notificationEndpoint,
    device: device,
    metadata: metadata
  };
};
exports.createConnectMessage = createConnectMessage;